import React from 'react'

export default function Footer(){

return(
    <div className="bg-success fontOdibee text-white" style={{PaddingBottom: "5%"}}>
        {/* <div classname="col-4"> */}
        <center>
            <h1 classname="mb-4 d-inline">&lt;Built-With-What /&gt; <span style={{fontSize: "small"}} className="d-inline fontVersion">v1.0 by Salman Qureshi</span></h1>
            
        </center>
        {/* </div> */}
        {/* <div classname="col-8"> */}

        {/* </div> */}
    </div>
)
}